// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-bagde>.v-badge__badge{bottom:15px!important;margin-left:20px!important}", ""]);
// Exports
module.exports = exports;
